import { Avatar, Box, Card, Grid, Typography } from "@mui/material";
import { blue, green, lightBlue, lightGreen, orange, purple, red } from "@mui/material/colors";
import pxToRem from "../../../../../Themes/Functions/pxToRem";

export default function ServiceTicket(props) {
  const { ticket } = props;
  const boxStyle = {
    cursor: "pointer",
    p: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  };

  const colours = [
    blue[800],
    green[500],
    purple[800],
    red[800],
    lightBlue[900],
    lightGreen[700],
    blue[900],
    green[900],
    orange[900],
    purple[900],
  ];
  const getColour = () => colours[Math.floor(Math.random() * colours.length)];

  return (
    <Card {...props} sx={boxStyle}>
      <Avatar size="md" sx={{ width: pxToRem(60), height: pxToRem(60), bgcolor: getColour }}>
        {ticket.count}
      </Avatar>
      <Typography noWrap fontSize={16} variant="h1" sx={{ color: "primary.main", m: 2 }}>
        {ticket.serviceName.toUpperCase()}
      </Typography>
    </Card>
  );
}
